const SELF_REPORTED_DATA_DESCRIPTION =
  'ESG performance based on verifiable reported data in the public domain. It captures and calculates over 630 company-level ESG measures, of which a subset of 186 of the most comparable and material per industry power the overall company assessment and scoring process.';

export default SELF_REPORTED_DATA_DESCRIPTION;
